import {
  SupabaseService,
  SupabaseServiceView,
} from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";
import type { UUID } from "../../../utils/uuid";

export type PopulatedProgram = Database["public"]["Views"]["populated_programs"]["Row"];
export type Program = Database["public"]["Tables"]["program"]["Row"];
export type UsedProgramInfo = Database["public"]["Views"]["used_programs_info"]["Row"];

export const programsOrder: { column: keyof Database["public"]["Tables"]["program"]["Row"] }[] = [
  { column: "order" },
  { column: "title" },
];

export class SupabaseProgramService extends SupabaseService<"program"> {
  table = "program" as const;

  /**
   * Inserts a program and does not read it back, so the caller makes its id. A new folder gets its
   * access from its parent only after the insert, so a contributor cannot read it in the insert.
   */
  async insertWithoutRead(
    program: Database["public"]["Tables"]["program"]["Insert"] & { id: UUID },
  ) {
    return this.log_errors(await this.client.from(this.table).insert(program));
  }

  async getAllPopulated() {
    return this.log_errors(await this.client.from("populated_programs").select("*"));
  }

  async getPopulated(id: UUID) {
    return this.log_errors(
      await this.client.from("populated_programs").select("*").eq("id", id).single(),
    );
  }

  async getPopulatedByTitle(title: string) {
    return this.log_errors(
      await this.client
        .from("populated_programs")
        .select("*")
        .is("visible", true)
        .like("title", title)
        .single(),
    );
  }
}

export class SupabaseUsedProgramInfoService extends SupabaseServiceView<"used_programs_info"> {
  table = "used_programs_info" as const;
}
